import { DATE_TIME_FORMAT } from '../common';
import surveysDispatcher from './action';
import ModalContainerForm from './component/ModalContainerForm';
import { COLUMN_SURVEY } from './constants';
import {
  AddIcon,
  CreateNewIcon,
  DeleteModalIcon,
  RemoveIcon,
} from '@/assets/svg';
import { momentFormatted } from '@/helpers';
import ModalConfirmation from '@/new-components/CustomModal/ModalConfirmation';
import CustomPaperContainer from '@/new-components/CustomPaperContainer';
import CustomHeader from '@/new-components/CustomPaperContainer/CustomHeader';
import CustomTable from '@/new-components/CustomTable';
import CustomTooltip from '@/new-components/CustomTooltip';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { debounce } from 'lodash';
import React, { useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const LifestyleSurvey = () => {
  const { list: data, paging } = useSelector((state) => state.surveys);

  const [searchKey, setSearchKey] = useState('');
  const [filterOption, setFilterOption] = useState({});

  const [openDrawer, setOpenDrawer] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isCreate, setIsCreate] = useState(true);
  const [selectedItem, setSelectedItem] = useState({});

  const fetchData = async (
    search = searchKey,
    pagingData = paging,
    filterOptionData = filterOption
  ) => {
    surveysDispatcher.getData(
      search,
      pagingData,
      ...[filterOptionData].filter((i) => i)
    );
  };

  const debounceLoadData = useCallback(
    debounce((searchKey, paging, sortOption, filterOption) => {
      fetchData(
        searchKey,
        {
          pageIndex: 0,
          pageSize: paging.pageSize,
        },
        sortOption,
        filterOption
      );
    }, 500),
    []
  );

  const onDeleteStation = () => {
    surveysDispatcher.deleteSurvey(selectedItem.id, () => {
      surveysDispatcher.getData(searchKey, {
        pageIndex: 0,
        pageSize: paging.pageSize,
      });
      setDeleteModal(false);
    });
  };

  useEffect(() => {
    debounceLoadData(searchKey, paging, filterOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey, filterOption]);

  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {COLUMN_SURVEY.map((item) => (
          <TableCell
            key={item.stateValue || item.label}
            style={{ minWidth: item.minWidth, width: item.width }}
          >
            {item.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );

  const renderTableBody = (row) => {
    return (
      <>
        <TableCell>
          <CustomTooltip
            content={
              <Typography dangerouslySetInnerHTML={{ __html: row.name }} />
            }
          />
        </TableCell>
        <TableCell>
          <CustomTooltip
            content={
              <Typography
                dangerouslySetInnerHTML={{ __html: row.description }}
              />
            }
          />
        </TableCell>
        <TableCell>
          {momentFormatted(row.updatedAt, DATE_TIME_FORMAT)}
        </TableCell>
        <TableCell>
          <IconButton
            onClick={() => {
              setIsCreate(false);
              setOpenDrawer(true);
              setSelectedItem({
                ...row,
                name: row.name
                  ? row.name.replace(/<br\s*\/?>/gi, '\n')
                  : row.name,
                description: row.description
                  ? row.description.replace(/<br\s*\/?>/gi, '\n')
                  : row.description,
                questions: row.questions.map((q) => ({
                  ...q,
                  question: q.question
                    ? q.question.replace(/<br\s*\/?>/gi, '\n')
                    : q.question,
                  questionDesc: q.questionDesc
                    ? q.questionDesc.replace(/<br\s*\/?>/gi, '\n')
                    : q.questionDesc,
                })),
              });
            }}
          >
            <AddIcon />
          </IconButton>
          <IconButton
            onClick={() => {
              setDeleteModal(true);
              setSelectedItem(row);
            }}
          >
            <RemoveIcon />
          </IconButton>
        </TableCell>
      </>
    );
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        disableBackdropClick
        PaperProps={{
          style: {
            width: '50%',
            minWidth: 768,
          },
        }}
      >
        <ModalContainerForm
          selectedItem={selectedItem}
          isCreate={isCreate}
          onClose={() => {
            setOpenDrawer(false);
            fetchData();
          }}
        />
      </Drawer>
      <CustomPaperContainer
        header={
          <CustomHeader
            searchPlaceholder="Search by survey name"
            title="Lifestyle survey"
            setSearchKey={setSearchKey}
            searchKey={searchKey}
            filterOption={filterOption}
            setFilterOption={setFilterOption}
            fetchData={fetchData}
            renderButton={() => (
              <Button
                color="primary"
                variant="contained"
                startIcon={<CreateNewIcon />}
                onClick={() => {
                  setOpenDrawer(true);
                  setIsCreate(true);
                }}
              >
                Create new
              </Button>
            )}
          />
        }
      >
        <CustomTable
          data={data}
          paging={paging}
          header={TableHeader}
          renderRow={(row, i) => renderTableBody(row)}
          noDataHelperText="No lifestyle survey"
          noDataHelperSubText="Please create a new lifestyle survey."
          totalCols={COLUMN_SURVEY.length}
          fetchData={fetchData}
          style={{ height: 'calc(100vh - 207px)' }}
        />
      </CustomPaperContainer>

      {deleteModal && (
        <ModalConfirmation
          confirmLabel="Delete"
          mainContent="Delete lifestyle survey"
          subContent="Are you sure you want to delete this lifestyle survey ?"
          open={deleteModal}
          confirmColor="red"
          Icon={<DeleteModalIcon />}
          onClose={() => setDeleteModal(false)}
          onClick={onDeleteStation}
        />
      )}
    </>
  );
};

export default LifestyleSurvey;
